<app-loader></app-loader>
<app-pulse-loader></app-pulse-loader>
<app-options></app-options>
<router-outlet></router-outlet>
